import { orderBy } from "lodash";

import { memoizeSelector } from "@/redux/helpers/memoizeSelector";

import { MODULE } from "./orders.actionTypes";

// `userSelector` calls `.toJS()`, which returns a new object every call - using it directly as a
// memoization input would never hit the cache. Read the underlying Immutable reference (stable
// between unrelated dispatches) and convert once inside the memoized result function instead.
const rawCurrentUser = (state) => state.getIn(["customers", "user"]);
const toJsUser = (user) => (user ? user.toJS() : null);

export const isFetchingOrders = (state) => state.getIn([MODULE, "isFetchingOrders"]);

export const isReplacingOrders = (state) => state.getIn([MODULE, "isReplacingOrders"]);

export const getOrders = (state) => state.getIn([MODULE, "orders"]);

export const getPagination = (state) => state.getIn([MODULE, "pagination"]);

export const getHasFetched = (state) => state.getIn([MODULE, "hasFetched"]);

export const getHasNextPage = (state) => state.getIn([MODULE, "hasNextPage"]);

export const getScheduleStateCounts = (state) => state.getIn([MODULE, "scheduleStateCounts"]);

export const getSortedAssignees = memoizeSelector(
  [rawCurrentUser, (_state, assignees) => assignees],
  (rawUser, assignees) => {
    const currentUser = toJsUser(rawUser);
    const formattedAssignees = assignees.map((a) =>
      a.id === currentUser.id ? { ...a, lastName: `${a.lastName} (You)` } : a
    );
    const sortedAssignees = [
      ...(formattedAssignees.some((a) => a.id === currentUser.id)
        ? [{ ...formattedAssignees.find((a) => a.id === currentUser.id) }]
        : []),
      ...orderBy(
        formattedAssignees.filter((a) => a.id !== currentUser.id),
        [(a) => a.firstName.toLowerCase()],
        "asc"
      ),
    ];

    return sortedAssignees;
  }
);

export const getSortedLabels = (_state, labels) => {
  const sortedLabels = orderBy(labels, [(l) => l.name.toLowerCase()]);
  return sortedLabels;
};
